module.exports = __webpack_public_path__ + "static/media/camera-retro.fd42ba19.svg";